import React from "react";
import { SxStyleProp } from "theme-ui";
import Text, { Props as TextProps } from "../Text/Text";

const styles = {
  h1: {
    fontSize: 7,
  },
  h2: {
    fontSize: 6,
  },
  h3: {
    fontSize: 5,
  },
  h4: {
    fontSize: 4,
  },
  h5: {
    fontSize: 3,
  },
  h6: {
    fontSize: 2,
  },
};

interface Props extends TextProps {
  sx?: SxStyleProp;
  css?: any;
  as?: keyof typeof styles;
}

const Heading: React.FunctionComponent<Props> = ({
  as = "h2",
  sx,
  fontWeight = "heading",
  ...restProps
}) => (
  <Text
    as={as}
    fontWeight={fontWeight}
    sx={{
      fontFamily: "heading",
      lineHeight: "heading",

      ...styles[as],
      ...(sx as any),
    }}
    {...restProps}
  />
);

export default Heading;
